import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CostCalculationService } from '../../../Services/cost-calculation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../Shared/Services/auth.service';
import { Router } from '@angular/router';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { UserType } from '../../../Shared/Enums/UserType';
import { TotalCostDTOVM } from '../../../Model/cost-calculation/TotalCostDTOVM';
import { AdditionalDetails, CostCalculationVM } from '../../../Model/cost-calculation/CostCalculationVM';
import { ProductMeterCostVM } from '../../../Model/cost-calculation/ProductMeterCostVM';
import { SharedService } from '../../../Shared/Services/shared.service';
import { DtoProductCostVM } from '../../../Model/cost-calculation/DtoProductCostVM';
import { DialogService } from '../../../Shared/Services/dialog.service';
import {SectorVM} from "../../../Model/SectorVM";
import {toSignal} from "@angular/core/rxjs-interop";
import {map} from "rxjs/operators";
import {FormControl} from "@angular/forms";
import {FloatLabelType} from "@angular/material/form-field";

@Component({
  selector: 'app-cost-calculation',
  templateUrl: './cost-calculation.component.html',
  styleUrl: './cost-calculation.component.scss'
})
export class CostCalculationComponent {
  @Input() TotalCostInputData: CostCalculationVM[] = [];
  @Input() SectorId: string | null = null;
  @Output() IsGetTotalCost = new EventEmitter<boolean>();
  TotalCostData: TotalCostDTOVM = {};
  costCalcAdds?: Record<string, AdditionalDetails[]>;

  constructor(private api: CostCalculationService, private shared: SharedService,
    private spinner: NgxSpinnerService, private auth: AuthService, private dialogService: DialogService,
    private router: Router, private toastrService: CustomToastrService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.spinner.show();
      this.GetTotalCost();
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetTotalCost() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.spinner.show();
      let data: DtoProductCostVM[] = this.api.GetDtoProductCostArrVM(this.TotalCostInputData);
      this.api.GetTotalCost({'sectorId': this.SectorId, 'products': data})
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.TotalCostData = data;
              this.costCalcAdds = this.GetGroupedCostCalcAdds();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetGroupedCostCalcAdds() {
    const AdditionalDetails: AdditionalDetails[] = [];
    this.TotalCostInputData.forEach(item => {
      item.AdditionalDetails?.forEach(data => {
        AdditionalDetails.push(data);
      });
    });

    const costCalcAdds = this.shared.groupBy<AdditionalDetails>(AdditionalDetails, (p: AdditionalDetails) => p.name);
    return costCalcAdds;
  }

  GetMeterCost(meterCosts?: ProductMeterCostVM[], cost?: CostCalculationVM, index?: number) {
    if (meterCosts && cost) {
      index = index ?? 1;
      return this.round((meterCosts![index]?.meterCost ?? 1) / (cost.count ?? 1), 2);
    }
    return 0;
  }

  ClacAllAdditions(data?: AdditionalDetails[]) {
    let cost = 0;

    data?.forEach(item => {
      cost += (item?.width ?? 1) * (item?.height ?? 1) * (item?.price ?? 1)
    });

    return cost;
  }

  Close() {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoBack',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.IsGetTotalCost.emit(false);
      }
    });
  }

  calcSquareMeter(data: CostCalculationVM): number | null{
    return this.round((data.width ?? 0) * (data.height ?? 0));
  }

  round(num: any, decimalPlaces = 0) {
    return Math.round( ( num + Number.EPSILON ) * 100 ) / 100;
  }
}
